import clsx from 'clsx';
import useOnClickOutside from '@/hooks/useClickOutside';
import { useRef, useState } from 'react';
import { Button } from '../Button/Button';

interface MobileDrawerPropsTypes {
  title: string;
  contentClassName: string;
  closeOnOutsideClick: boolean;
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
}

const MobileDrawer = ({
  children,
  title,
  contentClassName,
  onClose,
  closeOnOutsideClick = false,
  isOpen = false,
}: MobileDrawerPropsTypes) => {
  const mobileDrawerRef = useRef(null);
  const [isDrawerExpanded, setIsDrawerExpanded] = useState(false);

  useOnClickOutside(
    mobileDrawerRef,
    !closeOnOutsideClick
      ? () => {}
      : () => {
          onClose();
        }
  );

  return (
    <div
      ref={mobileDrawerRef}
      className={clsx(
        'fixed flex flex-col bottom-0 left-0 right-0 rounded-t-2xl shadow-[5px_5px_5px_rgba(15,8,91,0.9)] border border-ui bg-white duration-700 translate-y-full',
        isDrawerExpanded ? 'h-5/6' : 'h-[340px]',
        isOpen && 'translate-y-0'
      )}
    >
      <div className='flex justify-center '>
        <Button
          variant='solid'
          color='shadow'
          onClick={() => setIsDrawerExpanded(!isDrawerExpanded)}
          className='!h-1 !w-8 mt-1 mb-1 text-ui'
        />
      </div>
      <div className='flex justify-between px-3 py-2 border-b border-ui'>
        <div className='font-semibold text-base leading-5 text-midnight-600'>{title}</div>
        <div className=''>
          <Button size='small' iconName='x' onClick={onClose} variant='ghost' color='shadow' />
        </div>
      </div>
      <div className={`flex-1 flex flex-col bg-ui-secondary overflow-auto ${contentClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default MobileDrawer;
